import { lazy, Suspense } from 'react';

import type { LevelMappingProgressBlock } from '../../data-contract/chat';
import type { BlockRenderer } from './types';

const LevelMappingProgressCard = lazy(async () => {
    const { LevelMappingProgressCard } = await import('./LevelMappingProgressCard');

    return { default: LevelMappingProgressCard };
});

export const levelMappingProgressBlockRenderer: BlockRenderer<LevelMappingProgressBlock> = {
    isAnswered: () => true,
    renderInline: (block) => (
        <Suspense fallback={null}>
            <LevelMappingProgressCard block={block} />
        </Suspense>
    ),
    rendersInlineContent: () => true,
    type: 'level-mapping-progress',
};
